// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"20bb48e3","398":"beb8b803","452":"65213257","457":"ae780cce","498":"8d3ec8fd","728":"ea0be47c"}[chunkId] + ".chunk.js";
};